import React from "react";

import { Typography } from "new-components/typography/Typography";
import { TierType } from "types/users";

import { FINAL_STEPS, INITIAL_STEPS, TIER_TYPE_TO_PERK_INFO } from "./constants";
import { PlanPerksCard } from "./PlanPerksCard/PlanPerksCard";
import { StepContent, stepsContentProps } from "./types";

export function getStepsContent(tierType: TierType): stepsContentProps {
  const perkInfo = TIER_TYPE_TO_PERK_INFO[tierType];

  if (!perkInfo) {
    return [...INITIAL_STEPS, ...FINAL_STEPS];
  }

  const perkInfoStep: StepContent = {
    title: "Your current plan:",

    badge: perkInfo.title,
    image: <PlanPerksCard title={perkInfo.title} monthlyCost={perkInfo.monthlyCost} perks={perkInfo.perks} />,
    content: (
      <Typography>
        Find plan and usage details, including upgrade options by clicking on your username in the upper right and
        selecting “Account”.
      </Typography>
    ),
  };

  return [...INITIAL_STEPS, perkInfoStep, ...FINAL_STEPS];
}
